import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementItineraryRoutingModule } from './management-itinerary-routing.module';


// defineLocale('es', esLocale);

@NgModule({
    entryComponents:[
        // ModalPostBookingComponent
    ],
    imports: [

        CommonModule,
        // ReactiveFormsModule,
        // FormsModule,
        //TranslateModule,
        //NgbModule,
        ManagementItineraryRoutingModule,
        //LoadingModule.forRoot(configLoading);
        //NgxLoadingModule.forRoot(configLoading),
        // NgxSpinnerModule,
        // SharedModule,
        // BsDatepickerModule,


    ],
    declarations: [
        // ManagementItineraryComponent,
        // CardItineraryComponent,
        // FilterItineraryComponent
    ]
})
export class ManagementItineraryModule { }
